<template>
    <div id="pageTable">
        <v-container grid-list-xl fluid>
            <v-layout row wrap>
                <v-flex sm12 style="text-align:right">
                    <h3 style="float:left">Лог</h3>
                    <v-btn
                            color="blue"
                            dark
                            small
                            fab
                            @click="refresh()">
                        <v-icon>refresh</v-icon>
                    </v-btn>
                    <v-btn
                            color="pink"
                            dark
                            small
                            fab
                            @click="removeItemConfirm()">
                        <v-icon>delete</v-icon>
                    </v-btn>
                </v-flex>
                <v-flex lg12>
                    <v-card>
                        <v-toolbar card color="white">
                            <v-text-field
                                    flat
                                    solo
                                    prepend-icon="search"
                                    placeholder="Поиск"
                                    v-model="search"
                                    hide-details
                                    class="hidden-sm-and-down"
                            ></v-text-field>
                            <v-btn flat style="background-color: none;">
                                <v-switch   v-model="filterError" label="Только ошибки" color="error"></v-switch> 
                            </v-btn>
                            <v-btn icon>
                                <v-icon>filter_list</v-icon>
                            </v-btn>   
                        </v-toolbar>
                        <v-divider></v-divider>
                        <v-card-text class="pa-0">
                            <v-data-table
                                    :headers="complex.headers"
                                    :search="search"
                                    :items="filteredLogs"
                                    :rows-per-page-items="[10,25,50,100]"
                                    v-bind:pagination.sync="pagination"
                                    class="elevation-1"
                                    item-key="id"
                                    no-results-text="Нет результатов"
                                    rows-per-page-text="На странице"
                                    v-model="complex.selected"
                                
                            >
                                <template slot="headerCell" slot-scope="props">
                                    <v-tooltip bottom>
                                        <span slot="activator">
                                          {{ props.header.text }}
                                        </span>
                                        <span>
                                          {{ props.header.text }}
                                        </span>
                                    </v-tooltip>
                                </template>
                                <template slot="items" slot-scope="props">
                                    <tr> 
                                        <td>{{ props.item.id }}</td>
                                        <td>{{ props.item.lastModified }}</td>
                                        <td>{{ staffList.filter(staff => staff.value === props.item.userName).length > 0 ? staffList.filter(staff => staff.value === props.item.userName)[0].text : props.item.userName }}</td>
                                        <td>{{ props.item.procedureName }}</td>
                                        <td>{{ props.item.errormsgStr }}</td>
                                        <td> 
                                            <v-icon color="teal" v-if="props.item.typeLogId == 2">info</v-icon>
                                            <v-icon color="error" v-if="props.item.typeLogId == 1">error</v-icon> 
                                        </td>
                                        <td>

                                            <v-btn depressed outline icon fab dark color="blue" small @click="props.expanded = !props.expanded">
                                                <v-icon v-if="!props.expanded">expand_more</v-icon>
                                                <v-icon v-if="props.expanded">expand_less</v-icon>
                                            </v-btn>

                                            <v-btn depressed outline icon fab dark color="pink" small @click="removeItemConfirm(props.item)">
                                                <v-icon>delete</v-icon>
                                            </v-btn>

                                        </td>
                                    </tr>
                                </template>
                                <template slot="expand" slot-scope="props">
                                    <v-card flat  style="background:#f1f0f0;">
                                        <v-card-text>
                                            <v-layout row >
                                                <v-flex xs4>
                                                    <v-subheader>ID</v-subheader>
                                                </v-flex>
                                                <v-flex xs8 >
                                                    <v-subheader>{{ props.item.id }}</v-subheader>
                                                </v-flex>
                                            </v-layout>
                                            <v-layout row >
                                                <v-flex xs4>
                                                    <v-subheader>Название процедуры</v-subheader>
                                                </v-flex>
                                                <v-flex xs8 >
                                                    <v-subheader>{{ props.item.procedureName }}</v-subheader>
                                                </v-flex>
                                            </v-layout>
                                            <v-layout row >
                                                <v-flex xs4>
                                                    <v-subheader>SQL Code</v-subheader>
                                                </v-flex>
                                                <v-flex xs8 >
                                                    <v-subheader>{{ props.item.sqlcodeNum }}</v-subheader>
                                                </v-flex>
                                            </v-layout>
                                            <v-layout row >
                                                <v-flex xs4>
                                                    <v-subheader>SQL State</v-subheader>
                                                </v-flex>
                                                <v-flex xs8 >
                                                    <v-subheader>{{ props.item.sqlstateStr }}</v-subheader>
                                                </v-flex>
                                            </v-layout>
                                            <v-layout row >
                                                <v-flex xs4>
                                                    <v-subheader>Ошибка</v-subheader>
                                                </v-flex>
                                                <v-flex xs8 >
                                                    <v-subheader>{{ props.item.errormsgStr }}</v-subheader>
                                                </v-flex>
                                            </v-layout>
                                            <v-layout row >
                                                <v-flex xs4>
                                                    <v-subheader>Дата</v-subheader>
                                                </v-flex>
                                                <v-flex xs8 >
                                                    <v-subheader>{{ props.item.lastModified }}</v-subheader>
                                                </v-flex>
                                            </v-layout>
                                            <v-layout row >
                                                <v-flex xs4>
                                                    <v-subheader>Пользователь</v-subheader>
                                                </v-flex>
                                                <v-flex xs8 >
                                                    <v-subheader>{{ props.item.userName }}</v-subheader>
                                                </v-flex>
                                            </v-layout>
                                            <v-layout row >
                                                <v-flex xs4>
                                                    <v-subheader>Данные</v-subheader>
                                                </v-flex>
                                                <v-flex xs8 >
                                                    <v-subheader>{{ props.item.inputData }}</v-subheader>
                                                </v-flex>
                                            </v-layout>
                                            <v-layout row >
                                                <v-flex xs4>
                                                    <v-subheader>Тип записи</v-subheader>
                                                </v-flex>
                                                <v-flex xs8 >
                                                    <v-subheader>{{ props.item.typeLogId }}</v-subheader>
                                                </v-flex>
                                            </v-layout>
                                        </v-card-text>
                                    </v-card>
                                </template>
                            </v-data-table>


                            <!-- Удаление -->


                            <div slot="widget-content">
                                <v-dialog v-model="popupRemove.isOpen" persistent max-width="500px">
                                    <v-card>
                                        <v-card-title>
                                            <span v-if="complex.selected.length === 0" class="headline">Вы уверены что хотите удалить запись?</span>
                                            <span v-if="complex.selected.length !== 0" class="headline">Вы уверены что хотите удалить выделенные записи?</span>
                                        </v-card-title>
                                        <v-divider></v-divider>
                                        <v-card-actions>
                                            <v-spacer></v-spacer>
                                            <v-btn color="blue darken-1" flat @click.native="popupRemove.isOpen = false">Отмена</v-btn>
                                            <v-btn color="blue darken-1" flat @click.native="actionRemove();">Да, уверен</v-btn>
                                        </v-card-actions>
                                    </v-card>
                                </v-dialog>
                            </div>

                        </v-card-text>
                    </v-card>
                </v-flex>
            </v-layout>
        </v-container>
    </div>
</template>

<script>

    export default {
        components: {
        },
        data () {
            return {
                modalData: {},
                oldModalData: {},
                editedIndex: {},
                pagination: { sortBy: "id", descending: true}, // Сортировка по умолчанию для таблицы
                valid: true,
                readonlyFields: true,
                rules: {
                    required: [ v => !!v || 'Обязательное поле' ],
                    rolekey: [
                        v => !!v || 'Ключ не может быть пустым',
                        v => this.roleData.filter(el => el.roleKey === v).length === 0 || 'Такой ключ уже существует',
                    ],
                },
                search: '',
                filterError: false,
                popupRemove: {
                    isOpen: false
                },
                popupEdit: {
                    isOpen: false,
                    isEditing: false,
                },
                complex: {
                    selected: [],
                    headers: [
                        {
                            text: 'ID',
                            value: 'id'
                        },
                        {
                            text: 'Дата',
                            value: 'lastModified'
                        },
                        {
                            text: 'Пользователь',
                            value: 'userName'
                        },
                        {
                            text: 'Процедура',
                            value: 'procedureName'
                        },
                        {
                            text: 'Сообщение',
                            value: 'errormsgStr'
                        },
                        {
                            text: 'Тип',
                            value: 'typeLogId'
                        },
                        {
                            text: 'Действия',
                            value: ''
                        }
                    ],
                }
            };
        },

        computed: {

            /**
             * Данные Лога
             * @returns {default.computed.logData|(function())|Array|getters.logData}
             */
            logData () {
                return this.$store.getters['log/logData'];
                
            },
            /**
             * Список ответственных для таблицы
             * @returns {*}
             */
            staffList () {
                let tempStaff =  this.$store.getters['staff/staffData'].map(item => {
                    return { text: item.fullname, value: item.username }
                })  
                return tempStaff;
            },
            /**
            * Фильтруем данные логов по флагу "ошибка" 
            */

            filteredLogs() {
            let tempResponse = this.$store.getters['log/logData']; 
            if (this.filterError) {
                tempResponse = this.$store.getters['log/logData']
                .filter(lsd => lsd.typeLogId === 1);
            }  
            return tempResponse;
            },

        },

        mounted: function () {

            /**
             * Обновляем данные при каждом открытии вкладки
             */
            this.refresh(); 
            /**
             *  Если список staff пустой, обновить   
             */  
            if (this.$store.getters['staff/staffData'].length === 0)
            {   
                this.$store._actions['staff/getStaffData'][0]();
            }
        },

        methods: {

            /**
             * Обновление данных по ролям
             */
            refresh () {
                this.$store._actions['log/getLogData'][0]();
            },

            /**
             * Открытие модального окна с подтверждением удаления
             * @param data
             */
            removeItemConfirm (data) {
                this.popupRemove.isOpen = true;
                if (data !== null && typeof (data) !== 'undefined') { 
                    if (this.complex.selected.indexOf(data) === -1) {
                        this.complex.selected.push(data);
                    }
                }
            },

            /**
             * Удаление элемента
             * @param item
             */
            actionRemove () {
                // this.$store.commit('remove', {type: 'logData', item: item});
                // this.popupRemove.isOpen = false;
                this.$store._actions['log/removeLogData'][0]({items: this.complex.selected});
                this.popupRemove.isOpen = false;
            },
            /**
             * фильтр таблицы логфайла по ошибкам
             */
            filterErrorSwitch() {
            this.filterError = !this.filterError;
            },
        }
    };
</script>



// WEBPACK FOOTER //
// src/pages/ui/Log.vue